import { v4 } from 'uuid';
import * as Yup from 'yup';

import { FormBodyAPI } from 'src/constants/fieldsTypes';
import { BaseTextField } from 'src/legacy/components/TextField';

export const useAddTextForm = () => {
  const validationScheme = Yup.object().shape({
    value: Yup.string()
      .nullable()
      .trim()
      .required('Required')
      .max(4000, 'Maximum 4000 characters'),
  });

  const getSubmitValues = () => Promise.resolve({ key: v4() });

  const FormRenderer: React.FC<FormBodyAPI> = ({
    touched,
    errors,
    handleBlur,
    handleChange,
    values,
  }) => (
    <div>
      <BaseTextField
        sizeVariant="medium"
        error={Boolean(touched.value && errors.value)}
        fullWidth
        helperText={(touched.value && errors.value) || null}
        name="value"
        onBlur={handleBlur}
        variant="outlined"
        onChange={handleChange}
        value={values.value}
        autoFocus
        autoComplete="new-password"
        inputProps={{ maxLength: 4001 }}
        style={{
          minHeight: 80,
        }}
      />
    </div>
  );

  return { validationScheme, getSubmitValues, FormRenderer };
};
